import { Fighter } from "../types";

const warband: Fighter[] = [
  
];

export default warband;
